import { useRollbar as useRollbarLib } from '@rollbar/react';
import { useMemo, useRef } from 'react';

import { handleRollbarLog } from '@/utils/rollbar';

export default function useRollbar() {
  const rollbar = useRollbarLib();

  // To avoid rerender issue with Rollbar instance changing
  const rollbarRef = useRef(rollbar);
  rollbarRef.current = rollbar;

  return useMemo(
    () => ({
      log: handleRollbarLog('log', rollbarRef.current),
      error: handleRollbarLog('error', rollbarRef.current),
      info: handleRollbarLog('info', rollbarRef.current),
      debug: handleRollbarLog('debug', rollbarRef.current),
      critical: handleRollbarLog('critical', rollbarRef.current),
      warn: handleRollbarLog('warn', rollbarRef.current),
      warning: handleRollbarLog('warning', rollbarRef.current),
    }),
    [],
  );
}
